import React from 'react'
import AutoTooltip, { AutoTooltipContent } from '../AutoTooltip'
import BodyText from 'components/Luxkit/Typography/BodyText'
import moment from 'moment'
import { INTL_DMY_CASUAL_FORMAT } from 'constants/dateFormats'
import { intlFormatter } from 'lib/dateUtils'

const CONTENT_WIDTH = 204

interface Props extends React.PropsWithChildren {
  dates?: {
    bookBy: moment.Moment,
    travelUntil: moment.Moment,
  }
  customText?: string;
  onOpen?: () => void;
}

export default function GiftTooltip(props: Props) {
  const { children, dates, customText, onOpen } = props

  let msg = ''
  if (customText) {
    msg = customText
  } else if (dates) {
    msg = `Buy a package and send as a gift to a special someone. They can book by ${intlFormatter(dates.bookBy.toDate(), INTL_DMY_CASUAL_FORMAT)} and travel until ${intlFormatter(dates.travelUntil.toDate(), INTL_DMY_CASUAL_FORMAT)}.`
  }

  return <AutoTooltip onOpen={onOpen}>
    {children}
    <AutoTooltipContent width={CONTENT_WIDTH} position="above" type="dark">
      <BodyText variant="small">
        {msg}
      </BodyText>
    </AutoTooltipContent>
  </AutoTooltip>
}
